/* eslint-disable no-param-reassign */

/* eslint-disable max-len */
import produce from "immer";

import {
  GET_REPORT_COD_FAILURE,
  GET_REPORT_COD_REQUEST,
  GET_REPORT_COD_SUCCESS
} from "src/actions/codReportAction";

const initialState = {
  codReports: [],
  loading: false,
  totalDetailedReport: 0
};

const codReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_COD_REQUEST: {
      return produce(state, (draft) => {
        draft.codReports = [];
        draft.loading = true;
      });
    }

    case GET_REPORT_COD_SUCCESS: {
      const {response} = action.payload;
      const {
        res_total_detail_report: {total_items}
      } = response;
      return produce(state, (draft) => {
        draft.codReports = response;
        draft.totalDetailedReport = total_items;
        draft.loading = false;
      });
    }

    case GET_REPORT_COD_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default codReportReducer;
